module.exports = __webpack_public_path__ + "img/shopping-basket-solid.8fd54e94.svg";